<div class="contact-box">
    <div class="contact-image"></div>
    <div class="contact-body">
        <h2>Kontakt</h2>
        <p class="small">Hier finden Sie Ihre Ansprechpartner</p>
        <a [routerLink]="['/contact']" class="btn btn-primary small font-bold strict-sized-button mt-auto">Kontakt</a>
    </div>
</div>
